import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

export default function SubscriptionActionMenu({ subscription }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { navigateDetails, navigateEdit } = useGuardedNavigation('subscriptions');

  return (
    <>
      <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={() => navigateDetails(subscription.stripe_subscription_id)}>Details</MenuItem>
        <MenuItem onClick={() => navigateEdit(subscription.stripe_subscription_id)}>Edit</MenuItem>
      </Menu>
    </>
  );
}
